import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {LocalStorage} from 'ngx-store';
import { JwtHelperService } from '@auth0/angular-jwt';
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UniUserService {
  api: string = environment.apiUrl;
  headers: any;
  isLogged: boolean;
  isAdmin: boolean;
  @LocalStorage('loggedUser') loggedUser: any;
  @LocalStorage('userData') userData: any;

constructor(
  private http: HttpClient,
  private router: Router) {
  this.headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
}
async createUser(data: any): Promise<any>{
  return this.http
  .post(`${this.api}/usersRoles`, data, { headers: this.headers })
  .toPromise();
}

async getMemoryExperiment(): Promise<any>{
  return this.http
  .get(`${this.api}/memory_experiment`, { headers: this.headers })
  .toPromise();
}

async oddBall(): Promise<any>{
  return this.http
  .get(`${this.api}/odd_ball`, { headers: this.headers })
  .toPromise();
}

async questions(type): Promise<any>{
  return this.http
  .get(`${this.api}/question/answers?type=${type}`, { headers: this.headers })
  .toPromise();
}

async getSensoryAdaptation(): Promise<any>{
  return this.http
  .get(`${this.api}/sensory_adaptation`, { headers: this.headers })
  .toPromise();
}

async getTBW(): Promise<any>{
  return this.http
  .get(`${this.api}/tbw/trial`, { headers: this.headers })
  .toPromise();
}
async getCompletedTasks(): Promise<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
  return await this.http
    .get(this.api + `/tasks/completed_tasks`, { headers, observe: 'response' })
    .toPromise();
}

async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

  this.isLogged = this.loggedUser && this.userData;
  this.isAdmin = false
  const helper = new JwtHelperService();
  if (this.loggedUser && this.loggedUser.access_token) {
    const user = helper.decodeToken(this.loggedUser.access_token);
    if (user.role && user.role == "admin") this.isAdmin = true
  }

  //from this point we added a check on the logged user in order to not let him do the same task more than once

  const t = this.getCompletedTasks();

  const tasksHeDid = await t;

  let task = '';

  route.url.forEach(x => {
    task = x.path;
  });

  if (task == 'flash-beep') {
    task = 'FlashBeep'
  }
  if (task == 'personality-survey') {
    task = 'Personality'
  }
  if (task == 'memory-experiment') {
    task = 'WordCategorization'
  }
  if (task == 'loudness-perception') {
    task = 'LoudnessPerception'
  }
  if (task == 'target-detection') {
    task = 'TargetDetection'
  }
  if (task == 'questionnaire') {
    task = state.url.split('=')[1];
  }
  if (task == 'movement-perception') {
    task = 'MovementPerception'
  }
  let check = 0;

  tasksHeDid.body.forEach(x => {
    if (x == task) {
      check = 1;
    }
  })

  if (this.isLogged && !this.isAdmin && check == 0) {
    return true;
  } else {
    if (!this.isLogged) {
      alert('Please Log In')
    } else {
      if (check == 1) {
        alert('You already did this task')
      }
    }
    this.router.navigate(['']);
    return false;
  }
}

}
